export const positiveOutliers= "Positive outliers"
export const negativeOutliers= "Negative outliers"
export const DEFAULT_SORT_FIELD = "size"
export const DEFAULT_SORT_ORDER = "descend"
export const DESCEND = "descend"
export const NUMERIC_COLUMNS = ["vsWholeOrg","favScore","size"]
export const POSITIVE_OUTLIER="positiveOutliers"
export const NEGATIVE_OUTLIER="negativeOutliers"